import styled from "styled-components";

import { colorsPalettes, setFontVariant } from "@similarweb/styles";
import { FlexColumn, FlexRow } from "@similarweb/ui-components";

import ChangeIndication from "app/components/ChangeIndication/ChangeIndication";

const { carbon } = colorsPalettes;

export const PercentValue = styled.span`
    font-weight: 600;
    ${setFontVariant("caption", carbon[500])}
`;

export const Description = styled(FlexRow)`
    gap: 4px;
    ${setFontVariant("caption", carbon[300])}
`;

export const Title = styled.p`
    margin: 0;
    ${setFontVariant("h4", carbon[500])};
`;
export const ChangeIndicationBadge = styled(ChangeIndication)`
    .change-indication__value {
        font-size: 14px;
        line-height: normal;
    }
`;
export const TitleWrapper = styled(FlexColumn)`
    gap: 8px;
    align-items: flex-start;
`;
export const IndicatorWrapper = styled(FlexRow)`
    align-items: center;
    gap: 4px;
`;
export const Container = styled(FlexColumn)`
    gap: 4px;
`;
